/** «Рассылки» → «Брони» → «Переезд в Москву» — ровно то, что отдаёт `GET /api/mailing/moved`. */
import { apiFetch } from "@/lib/api";

/** Состояние брони в рассылке; ключи — те же, что у выборки «Чатов» `/chats?moved=`. */
export type MovedState = "today" | "sent" | "later" | "skip" | "cancel" | "error";

export type MovedRow = {
  deal: number;
  phone: string;
  /** Брони — дата выдачи (`rentStart` договора), ГГГГ-ММ-ДД; записанные — время примерки ГГГГ-ММ-ДДTЧЧ:ММ. */
  start: string | null;
  /** Дней до выдачи от сегодня (МСК). */
  days: number | null;
  state: MovedState;
  /** Куда уйдёт (сегодня, позже) или куда ушло (отправлено): «бот MAX», «шаблон WhatsApp», «мост» … */
  channel: string;
  /** Отправлено — дата и время; сегодня и позже — день, когда напишем. */
  when: string;
  /** Почему не пишем, сняли или ошибка. */
  note: string;
  /** Чат, который открыть: куда ушло сообщение, иначе самый свежий чат клиента. */
  chat_id: number | null;
  chats: number[];
  /** Только у отправленных: дошло ли и прочитал ли. */
  read?: MovedRead;
};

/**
 * Прочтение знаем только там, где его сообщает площадка: шаблон WhatsApp (статус Wazzup) и мост (галки).
 * Боты Telegram и MAX о прочтении не сообщают (`bot`) — для них только косвенно: ответил, открыл push.
 */
export type MovedRead = {
  state: "read" | "delivered" | "sent" | "failed" | "bot";
  label: string;
  /** Когда прочитал (или доставлено), МСК. */
  at: string | null;
  /** Первое сообщение клиента в его чатах после рассылки. */
  replied: string | null;
  /** Клиент открыл push-уведомление брони. */
  push_opened: string | null;
};

/** Сводка по отправленным: `known` — где прочтение видно (WhatsApp, мост), `read` — из них прочитали. */
export type MovedReadSummary = { sent: number; known: number; read: number; replied: number; push_opened: number };

export type MailingMoved = {
  today: string;
  /** Брони — день переезда; записанные — момент смены адреса в рассылках. */
  moves: { location: number; city: string; date: string }[];
  /** До выдачи меньше стольких дней — пора писать. */
  days: number;
  /** Фон шлёт сам (`PROKAT_MAILING_MOVED_SEND`); выключено — только предпросмотр. */
  send_on: boolean;
  /** Окно 10–21 салона открыто сейчас. */
  window: boolean;
  states: Record<MovedState, string>;
  counts: Record<MovedState | "all", number>;
  read: MovedReadSummary;
  rows: MovedRow[];
};

/** Кого показываем: брони до переезда или записанных на примерку до смены адреса. */
export type MovedKind = "bron" | "zapis";

export function loadMailingMoved(kind: MovedKind = "bron"): Promise<MailingMoved> {
  return apiFetch<MailingMoved>(`/api/mailing/moved?kind=${kind}`);
}
